import { combineReducers } from 'redux';
import authSlice from '@/redux/auth';
import cacheSlice from '@/redux/cache';
import realtimeSlice from '@/redux/realtime';
import domSlice from './dom';
import isNewSlice from './user_search/is_new';
import httpReqsSlice from './slices/httpReqsSlice';
import agentSlice from './slices/agent';
import agentAccessTokenSlice from './slices/agentAccessToken';
import newCountSlice from './slices/newCount';

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  cache: cacheSlice.reducer,
  realtime: realtimeSlice.reducer,
  dom: domSlice.reducer,
  is_new: isNewSlice.reducer,
  httpReqs: httpReqsSlice.reducer,
  agent: agentSlice.reducer,
  agentAccessToken: agentAccessTokenSlice.reducer,
  newCount: newCountSlice.reducer,
});

type RootState = ReturnType<typeof rootReducer>;

declare module 'react-redux' {
  interface DefaultRootState extends RootState {}
}

export default rootReducer;
